<template>
    <div class="row overview-loader">
        <div class="col text-center">
            <img src="/themes/custom/ef2_custom/img/cp-icon.svg" alt="Loader">
        </div>
    </div>
</template>

<script>
import inViewport from './../../../../../themes/custom/ef2_custom/node_modules/vue-in-viewport-mixin';

export default {
    name: "Loader",

    mixins: [inViewport],

    watch: {
        'inViewport.now': function(visible) {
            this.$emit('loader-visibility', { visible: visible });
        }
    }
}
</script>